<script context="module" lang="ts">var _a, _b, _c;
export { specification } from "./spec";
</script>

<script lang="ts">var _a, _b, _c;
import { get } from "lodash";
import { BaseAtom, getModeManager } from "components/cards/atoms";
import { resizeObserverAction } from "../../../../common/actions";
import { TextParticle, ImageParticle, } from "components/cards/particles/YinzCam";
import { onDestroy } from "svelte";
export let container;
export let containerPadding;
export let txtMinutes;
export let txtTitle;
export let txtCommentary;
export let imgTitleIcon;
export let imgCommentTeamLogo;
export let isEventIcon;
export let variantType;
export let htmlContent;
export let quoteText;
export let quoteBorderColor;
export let imgPlayerPhoto;
export let txtEventText;
export let photoBackgroundColor;
export let eventType;
export let txtExtra;
export let txtMins;
export let commentTeam;
export let shapeColor;
export let shapeColorNormal;
export let lineColor;
export let imgPlayerOff;
export let imgPlayerOn;
export let txtPlayerOff;
export let txtPlayerOn;
export let txtPlayerSub;
export let darkTitleColor;
export let lightTitleColor;
export let darkMinsColor;
export let lightMinsColor;
export let darkBodyColor;
export let lightBodyColor;
export let lightPlayerColor;
export let darkPlayerColor;
export let lastCard;
export let firstCard;
export let primaryEventBackground;
export let secondaryEventBackground;
export let commentsCount;
let atomWidthRem;
let titleDisplayEvents = [
    "END_PERIOD",
    "SUB",
    "YELLOW",
    "RED",
    "GOAL",
    "START_PERIOD",
];
let iconDisplayEvents = [
    "END_PERIOD",
    "SUB",
    "YELLOW",
    "RED",
    "START_PERIOD",
];
const eventIconMap = {
    SUB: "https://resources-uk.yinzcam.com/soccer/shared/icon_switch.svg",
    GOAL: "https://resources-uk.yinzcam.com/soccer/shared/soccer_ball.png",
    YELLOW: "https://resources-uk.yinzcam.com/soccer/shared/yellow_card.png",
    RED: "https://resources-uk.yinzcam.com/soccer/shared/red_card.png",
    END_PERIOD: "https://resources-uk.yinzcam.com/soccer/shared/icon_referee_whistle.svg",
    START_PERIOD: "https://resources-uk.yinzcam.com/soccer/shared/icon_referee_whistle.svg",
    others: "yc_icon_add",
};
$: mins = (_a = txtMinutes === null || txtMinutes === void 0 ? void 0 : txtMinutes.text) === null || _a === void 0 ? void 0 : _a.split("+")[0].replace("'", "");
$: extra =
    ((_b = txtMinutes === null || txtMinutes === void 0 ? void 0 : txtMinutes.text) === null || _b === void 0 ? void 0 : _b.split("+")[1]) &&
        ` +${(_c = txtMinutes === null || txtMinutes === void 0 ? void 0 : txtMinutes.text) === null || _c === void 0 ? void 0 : _c.split("+")[1].replace("'", "")}`;
$: shouldApplyBackgroundColor =
    ["END_PERIOD", "START_PERIOD"].includes(eventType) ||
        (eventType === "GOAL" &&
            CONFIG.tricode.toLowerCase() === commentTeam.toLowerCase());
$: shouldApplyGrayBackground = ["SUB", "YELLOW", "RED", "GOAL"].includes(eventType);
$: txtMinsMultiplier = atomWidthRem < 40 ? "0.7" : "1.00";
$: titleColor = shouldApplyBackgroundColor
    ? lightTitleColor
    : darkTitleColor;
$: minsColor = shouldApplyBackgroundColor ? lightMinsColor : darkMinsColor;
$: bodyColor = shouldApplyBackgroundColor ? lightBodyColor : darkBodyColor;
$: playerColor = shouldApplyBackgroundColor
    ? lightPlayerColor
    : darkPlayerColor;
$: isMobile = atomWidthRem < 40;
let eleMinsText;
let elePlayerImage;
let resizeObserver;
let overlapWidth;
let isOverlapping;
function handleOverlap() {
    if (eleMinsText && elePlayerImage) {
        let rectMinsText = eleMinsText.getBoundingClientRect();
        let rectPlayerImage = elePlayerImage.getBoundingClientRect();
        isOverlapping = (rectMinsText === null || rectMinsText === void 0 ? void 0 : rectMinsText.bottom) > (rectPlayerImage === null || rectPlayerImage === void 0 ? void 0 : rectPlayerImage.top);
        if (isOverlapping) {
            overlapWidth = `${Math.ceil((rectMinsText === null || rectMinsText === void 0 ? void 0 : rectMinsText.bottom) - (rectPlayerImage === null || rectPlayerImage === void 0 ? void 0 : rectPlayerImage.top) + 25)}px`;
            eleMinsText.classList.add("overlapping-div");
        }
    }
}
$: if (eleMinsText || elePlayerImage) {
    handleOverlap();
}
onDestroy(() => {
    if (resizeObserver) {
        resizeObserver.disconnect();
    }
});
const langStore = getModeManager().getCurrentLanguageStore();
$: minsLsmOverride = (CONFIG.league === 'fa' && CONFIG.tricode === 'lei' && $langStore === 'th') ? '0.78' : undefined;
$: commentLsmOverride = (CONFIG.league === 'fa' && CONFIG.tricode === 'lei' && $langStore === 'th') ? '1.15' : undefined;
</script>

<BaseAtom
    bind:_clientWidthRem={atomWidthRem}
    _isotope="MCCommentaryBAtom"
    _cssVariablePrefix="mc-commentary"
    {...container}
    {containerPadding}
    {quoteBorderColor}
    {photoBackgroundColor}
    {shapeColor}
    {shapeColorNormal}
    {primaryEventBackground}
    {secondaryEventBackground}
    {lineColor}
    {overlapWidth}
>
    {#if eventType}
        <div
            class="main-container"
            class:tablet-layout={atomWidthRem < 72 && atomWidthRem >= 40}
            class:mobile-layout={atomWidthRem < 40}
        >
            <div class="shape-content">
                <div
                    class={!lastCard && !(commentsCount === 1)
                        ? "line-shape-top"
                        : "line-shape-top-plain"}
                ></div>
                <div
                    class="circle-shape"
                    class:gray-dot={!titleDisplayEvents.includes(eventType)}
                ></div>
                {#if !firstCard && !(commentsCount === 1)}<div
                        class="line-shape-bot"
                    ></div>{/if}
            </div>
            <div
                class="comment-content"
                class:apply-background={shouldApplyBackgroundColor}
                class:three-column={["END_PERIOD", "START_PERIOD"].includes(
                    eventType,
                )}
                class:apply-gray-background={shouldApplyGrayBackground}
                class:single-column={!mins &&
                    !imgCommentTeamLogo?.source &&
                    !["END_PERIOD", "START_PERIOD"].includes(eventType)}
                class:two-column={!imgCommentTeamLogo?.source &&
                    !["END_PERIOD", "START_PERIOD"].includes(eventType)}
            >
                <div class="minutes">
                    {#if mins}
                        <div
                            class="minutes-text"
                            bind:this={eleMinsText}
                            use:resizeObserverAction={handleOverlap}
                            class:overlapping-div={isOverlapping}
                        >
                            <div class="mins-extras">
                                <TextParticle
                                    _block={true}
                                    {...txtMinutes}
                                    text={mins}
                                    size={`calc(${get(txtMinutes, "size")}*${txtMinsMultiplier})`}
                                    color={minsColor}
                                />
                                {#if mins}
                                    <TextParticle
                                        {...txtMins}
                                        text="MINS"
                                        color={minsColor}
                                        _block={true}
                                        _lsmOverride={minsLsmOverride}
                                    />
                                {/if}
                            </div>
                            <div class="mins-text">
                                {#if extra}
                                    <TextParticle
                                        {...txtExtra}
                                        text={extra}
                                        color={minsColor}
                                        _block={true}
                                    />
                                {/if}
                                <div></div>
                            </div>
                        </div>
                        {#if eventType === "GOAL" && CONFIG.tricode.toLowerCase() === commentTeam.toLowerCase()}
                            <div
                                class="comment-player-image"
                                bind:this={elePlayerImage}
                                use:resizeObserverAction={handleOverlap}
                            >
                                <ImageParticle
                                    {...imgPlayerPhoto}
                                    _block={true}
                                />
                            </div>
                        {/if}
                    {/if}
                </div>
                {#if !["END_PERIOD", "START_PERIOD"].includes(eventType) && imgCommentTeamLogo?.source}
                    <div
                        class="comm-team-logo"
                        class:mobile={atomWidthRem < 45}
                    >
                        {#if imgCommentTeamLogo?.source}
                            <ImageParticle
                                {...imgCommentTeamLogo}
                                _block={true}
                            />
                        {/if}
                    </div>
                {/if}
                <div class="commentary-box">
                    {#if !!txtTitle?.text && txtTitle?.text !== "false" && titleDisplayEvents.includes(eventType)}
                        <div class="title">
                            <TextParticle {...txtTitle} color={titleColor} />
                        </div>
                    {/if}
                    <div class="commentary">
                        {#if eventType === "SUB"}
                            <div class="sub-players">
                                <div class="player-off">
                                    <ImageParticle
                                        {...imgPlayerOff}
                                        _block={true}
                                        source="https://resources-uk.yinzcam.com/soccer/shared/icon_sub_off.svg"
                                    />
                                    <TextParticle
                                        {...txtPlayerOff}
                                        color={playerColor}
                                    />
                                    {#if !isMobile}
                                        <TextParticle
                                            {...txtPlayerSub}
                                            text="Player Off"
                                        />
                                    {/if}
                                </div>
                                <div class="player-on">
                                    <ImageParticle
                                        {...imgPlayerOn}
                                        _block={true}
                                        source="https://resources-uk.yinzcam.com/soccer/shared/icon_sub_on.svg"
                                    />
                                    <TextParticle
                                        {...txtPlayerOn}
                                        color={playerColor}
                                    />
                                    {#if !isMobile}
                                        <TextParticle
                                            {...txtPlayerSub}
                                            text="Player On"
                                        />
                                    {/if}
                                </div>
                            </div>
                        {:else if txtCommentary?.text}
                            <TextParticle
                                {...txtCommentary}
                                color={bodyColor}
                                _block={true}
                                _lsmOverride={commentLsmOverride}
                            />
                        {/if}
                    </div>
                </div>
                {#if iconDisplayEvents.includes(eventType)}
                    <div class="title-icon" class:mobile={atomWidthRem < 65}>
                        <ImageParticle
                            {...imgTitleIcon}
                            _block={true}
                            source={eventIconMap[eventType]}
                        />
                    </div>
                {/if}
            </div>
            <!-- <div class="bottom-content">
            {#if variantType !== "comment"}
                {#if variantType === "comment-and-embed"}
                    <div class="rich-text-content">
                        <RichTextParticle {...htmlContent} />
                    </div>
                {/if}
                {#if variantType === "comment-and-quote"}
                    <div class="quote-content">
                        <TextParticle {...quoteText} />
                    </div>
                {/if}
                {#if variantType === "comment-and-photo" && imgPlayerPhoto?.source}
                    <div class="photo-content">
                        <div class="wave-pattern-top">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="183"
                                height="113"
                                viewBox="0 0 183 113"
                                fill="none"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M-8.5 -7C-5.33333 -5.5 2.8 -2.5 10 -2.5C14.3815 -2.5 17.4595 -4.27755 20.6185 -6.10191C23.9484 -8.02495 27.3683 -10 32.5 -10C37.0369 -10 41.0592 -8.45626 45.454 -6.76952C50.7461 -4.73843 56.5785 -2.5 64.5 -2.5C72.2499 -2.5 74.715 -4.64249 77.0101 -6.63725C79.0092 -8.37466 80.8792 -10 86 -10C91.5 -10 96.875 -8.125 102.25 -6.25C107.625 -4.375 113 -2.5 118.5 -2.5C124.131 -2.5 127.142 -4.4654 130.08 -6.38398C132.882 -8.21327 135.619 -10 140.5 -10C145.221 -10 149.497 -8.32816 154.011 -6.56315C159.057 -4.5898 164.402 -2.5 171 -2.5C175.885 -2.5 182.839 -5.36385 183 -6.89438V7C181.5 8.33333 177 11 171 11C164.149 11 158.2 8.74723 152.822 6.711C148.387 5.03188 144.341 3.5 140.5 3.5C136.25 3.5 132.875 5.375 129.5 7.25C126.125 9.125 122.75 11 118.5 11C114.186 11 107.939 9.06774 101.787 7.16476C95.8186 5.3186 89.9394 3.5 86 3.5C82.4831 3.5 80.4157 4.94941 78.0985 6.57389C75.1447 8.6447 71.7851 11 64.5 11C57.6533 11 52.0548 8.91963 46.7549 6.95023C41.9918 5.1803 37.47 3.5 32.5 3.5C27.0766 3.5 23.7074 5.50091 20.4496 7.43573C17.4001 9.24682 14.4481 11 10 11C6.16667 11 -2.9 10.1 -8.5 6.5V-7ZM183 -7V-6.89438C183.004 -6.93034 183.004 -6.96557 183 -7ZM-8.5 18.5C-5.33333 20 2.8 23 10 23C14.3815 23 17.4595 21.2225 20.6185 19.3981C23.9484 17.4751 27.3683 15.5 32.5 15.5C37.0369 15.5 41.0592 17.0437 45.454 18.7305C50.7461 20.7616 56.5785 23 64.5 23C72.2499 23 74.715 20.8575 77.0101 18.8628C79.0092 17.1253 80.8792 15.5 86 15.5C91.5 15.5 96.875 17.375 102.25 19.25C107.625 21.125 113 23 118.5 23C124.131 23 127.142 21.0346 130.08 19.116C132.882 17.2867 135.619 15.5 140.5 15.5C145.221 15.5 149.497 17.1718 154.011 18.9369C159.057 20.9102 164.402 23 171 23C175.885 23 182.839 20.1362 183 18.6056V32.5C181.5 33.8333 177 36.5 171 36.5C164.149 36.5 158.2 34.2472 152.822 32.211C148.387 30.5319 144.341 29 140.5 29C136.25 29 132.875 30.875 129.5 32.75C126.125 34.625 122.75 36.5 118.5 36.5C114.186 36.5 107.939 34.5677 101.787 32.6648C95.8186 30.8186 89.9394 29 86 29C82.4831 29 80.4157 30.4494 78.0985 32.0739C75.1447 34.1447 71.7851 36.5 64.5 36.5C57.6533 36.5 52.0548 34.4196 46.7549 32.4502C41.9918 30.6803 37.47 29 32.5 29C27.0766 29 23.7074 31.0009 20.4496 32.9357C17.4001 34.7468 14.4481 36.5 10 36.5C6.16667 36.5 -2.9 35.6 -8.5 32V18.5ZM183 18.6056V18.5C183.002 18.514 183.002 18.5281 183.003 18.5424C183.003 18.5632 183.002 18.5843 183 18.6056ZM10 48.5C2.8 48.5 -5.33333 45.5 -8.5 44V57.5C-2.9 61.1 6.16667 62 10 62C14.4481 62 17.4001 60.2468 20.4496 58.4357C23.7074 56.5009 27.0766 54.5 32.5 54.5C37.47 54.5 41.9918 56.1803 46.7549 57.9502C52.0548 59.9196 57.6533 62 64.5 62C71.7851 62 75.1447 59.6447 78.0985 57.5739C80.4157 55.9494 82.4831 54.5 86 54.5C89.9394 54.5 95.8186 56.3186 101.787 58.1648C107.939 60.0677 114.186 62 118.5 62C122.75 62 126.125 60.125 129.5 58.25C132.875 56.375 136.25 54.5 140.5 54.5C144.341 54.5 148.387 56.0319 152.822 57.711C158.2 59.7472 164.149 62 171 62C177 62 181.5 59.3333 183 58V44.1056C183.004 44.0697 183.004 44.0344 183 44V44.1056C182.839 45.6362 175.885 48.5 171 48.5C164.402 48.5 159.057 46.4102 154.011 44.4369C149.497 42.6718 145.221 41 140.5 41C135.619 41 132.882 42.7867 130.08 44.616C127.142 46.5346 124.131 48.5 118.5 48.5C113 48.5 107.625 46.625 102.25 44.75C96.875 42.875 91.5 41 86 41C80.8792 41 79.0092 42.6253 77.0101 44.3628C74.715 46.3575 72.2499 48.5 64.5 48.5C56.5785 48.5 50.7461 46.2616 45.454 44.2305C41.0592 42.5437 37.0369 41 32.5 41C27.3683 41 23.9484 42.9751 20.6185 44.8981C17.4595 46.7225 14.3815 48.5 10 48.5ZM-8.5 69.5C-5.33333 71 2.8 74 10 74C14.3815 74 17.4595 72.2225 20.6185 70.3981C23.9484 68.4751 27.3683 66.5 32.5 66.5C37.0369 66.5 41.0592 68.0437 45.454 69.7305C50.7461 71.7616 56.5785 74 64.5 74C72.2499 74 74.715 71.8575 77.0101 69.8627C79.0092 68.1253 80.8792 66.5 86 66.5C91.5 66.5 96.875 68.375 102.25 70.25C107.625 72.125 113 74 118.5 74C124.131 74 127.142 72.0346 130.08 70.116C132.882 68.2867 135.619 66.5 140.5 66.5C145.221 66.5 149.497 68.1718 154.011 69.9369C159.057 71.9102 164.402 74 171 74C175.885 74 182.839 71.1362 183 69.6056V83.5C181.5 84.8333 177 87.5 171 87.5C164.149 87.5 158.2 85.2472 152.822 83.211C148.387 81.5319 144.341 80 140.5 80C136.25 80 132.875 81.875 129.5 83.75C126.125 85.625 122.75 87.5 118.5 87.5C114.186 87.5 107.939 85.5677 101.787 83.6648C95.8186 81.8186 89.9394 80 86 80C82.4831 80 80.4157 81.4494 78.0985 83.0739C75.1447 85.1447 71.7851 87.5 64.5 87.5C57.6533 87.5 52.0548 85.4196 46.7549 83.4502C41.9918 81.6803 37.47 80 32.5 80C27.0766 80 23.7074 82.0009 20.4496 83.9357C17.4001 85.7468 14.4481 87.5 10 87.5C6.16667 87.5 -2.9 86.6 -8.5 83V69.5ZM183 69.5V69.6056C183.004 69.5697 183.004 69.5344 183 69.5ZM10 99.5C2.8 99.5 -5.33333 96.5 -8.5 95V108.5C-2.9 112.1 6.16667 113 10 113C14.4481 113 17.4001 111.247 20.4496 109.436C23.7074 107.501 27.0766 105.5 32.5 105.5C37.47 105.5 41.9918 107.18 46.7549 108.95C52.0548 110.92 57.6533 113 64.5 113C71.7851 113 75.1447 110.645 78.0985 108.574C80.4157 106.949 82.4831 105.5 86 105.5C89.9394 105.5 95.8186 107.319 101.787 109.165C107.939 111.068 114.186 113 118.5 113C122.75 113 126.125 111.125 129.5 109.25C132.875 107.375 136.25 105.5 140.5 105.5C144.341 105.5 148.387 107.032 152.822 108.711C158.2 110.747 164.149 113 171 113C177 113 181.5 110.333 183 109V95.1056C183.004 95.0697 183.004 95.0344 183 95V95.1056C182.839 96.6362 175.885 99.5 171 99.5C164.402 99.5 159.057 97.4102 154.011 95.4369C149.497 93.6718 145.221 92 140.5 92C135.619 92 132.882 93.7867 130.08 95.616C127.142 97.5346 124.131 99.5 118.5 99.5C113 99.5 107.625 97.625 102.25 95.75C96.875 93.875 91.5 92 86 92C80.8792 92 79.0092 93.6253 77.0101 95.3627C74.715 97.3575 72.2499 99.5 64.5 99.5C56.5785 99.5 50.7461 97.2616 45.454 95.2305C41.0592 93.5437 37.0369 92 32.5 92C27.3683 92 23.9484 93.9751 20.6185 95.8981C17.4595 97.7225 14.3815 99.5 10 99.5Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                        <div class="text-image">
                            <div class="player-image">
                                <ImageParticle {...imgPlayerPhoto} />
                            </div>
                            <div class="photo-text">
                                <TextParticle {...txtEventText} />
                            </div>
                        </div>
                        <div class="wave-pattern-bottom">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="183"
                                height="113"
                                viewBox="0 0 183 113"
                                fill="none"
                            >
                                <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M-8.5 -7C-5.33333 -5.5 2.8 -2.5 10 -2.5C14.3815 -2.5 17.4595 -4.27755 20.6185 -6.10191C23.9484 -8.02495 27.3683 -10 32.5 -10C37.0369 -10 41.0592 -8.45626 45.454 -6.76952C50.7461 -4.73843 56.5785 -2.5 64.5 -2.5C72.2499 -2.5 74.715 -4.64249 77.0101 -6.63725C79.0092 -8.37466 80.8792 -10 86 -10C91.5 -10 96.875 -8.125 102.25 -6.25C107.625 -4.375 113 -2.5 118.5 -2.5C124.131 -2.5 127.142 -4.4654 130.08 -6.38398C132.882 -8.21327 135.619 -10 140.5 -10C145.221 -10 149.497 -8.32816 154.011 -6.56315C159.057 -4.5898 164.402 -2.5 171 -2.5C175.885 -2.5 182.839 -5.36385 183 -6.89438V7C181.5 8.33333 177 11 171 11C164.149 11 158.2 8.74723 152.822 6.711C148.387 5.03188 144.341 3.5 140.5 3.5C136.25 3.5 132.875 5.375 129.5 7.25C126.125 9.125 122.75 11 118.5 11C114.186 11 107.939 9.06774 101.787 7.16476C95.8186 5.3186 89.9394 3.5 86 3.5C82.4831 3.5 80.4157 4.94941 78.0985 6.57389C75.1447 8.6447 71.7851 11 64.5 11C57.6533 11 52.0548 8.91963 46.7549 6.95023C41.9918 5.1803 37.47 3.5 32.5 3.5C27.0766 3.5 23.7074 5.50091 20.4496 7.43573C17.4001 9.24682 14.4481 11 10 11C6.16667 11 -2.9 10.1 -8.5 6.5V-7ZM183 -7V-6.89438C183.004 -6.93034 183.004 -6.96557 183 -7ZM-8.5 18.5C-5.33333 20 2.8 23 10 23C14.3815 23 17.4595 21.2225 20.6185 19.3981C23.9484 17.4751 27.3683 15.5 32.5 15.5C37.0369 15.5 41.0592 17.0437 45.454 18.7305C50.7461 20.7616 56.5785 23 64.5 23C72.2499 23 74.715 20.8575 77.0101 18.8628C79.0092 17.1253 80.8792 15.5 86 15.5C91.5 15.5 96.875 17.375 102.25 19.25C107.625 21.125 113 23 118.5 23C124.131 23 127.142 21.0346 130.08 19.116C132.882 17.2867 135.619 15.5 140.5 15.5C145.221 15.5 149.497 17.1718 154.011 18.9369C159.057 20.9102 164.402 23 171 23C175.885 23 182.839 20.1362 183 18.6056V32.5C181.5 33.8333 177 36.5 171 36.5C164.149 36.5 158.2 34.2472 152.822 32.211C148.387 30.5319 144.341 29 140.5 29C136.25 29 132.875 30.875 129.5 32.75C126.125 34.625 122.75 36.5 118.5 36.5C114.186 36.5 107.939 34.5677 101.787 32.6648C95.8186 30.8186 89.9394 29 86 29C82.4831 29 80.4157 30.4494 78.0985 32.0739C75.1447 34.1447 71.7851 36.5 64.5 36.5C57.6533 36.5 52.0548 34.4196 46.7549 32.4502C41.9918 30.6803 37.47 29 32.5 29C27.0766 29 23.7074 31.0009 20.4496 32.9357C17.4001 34.7468 14.4481 36.5 10 36.5C6.16667 36.5 -2.9 35.6 -8.5 32V18.5ZM183 18.6056V18.5C183.002 18.514 183.002 18.5281 183.003 18.5424C183.003 18.5632 183.002 18.5843 183 18.6056ZM10 48.5C2.8 48.5 -5.33333 45.5 -8.5 44V57.5C-2.9 61.1 6.16667 62 10 62C14.4481 62 17.4001 60.2468 20.4496 58.4357C23.7074 56.5009 27.0766 54.5 32.5 54.5C37.47 54.5 41.9918 56.1803 46.7549 57.9502C52.0548 59.9196 57.6533 62 64.5 62C71.7851 62 75.1447 59.6447 78.0985 57.5739C80.4157 55.9494 82.4831 54.5 86 54.5C89.9394 54.5 95.8186 56.3186 101.787 58.1648C107.939 60.0677 114.186 62 118.5 62C122.75 62 126.125 60.125 129.5 58.25C132.875 56.375 136.25 54.5 140.5 54.5C144.341 54.5 148.387 56.0319 152.822 57.711C158.2 59.7472 164.149 62 171 62C177 62 181.5 59.3333 183 58V44.1056C183.004 44.0697 183.004 44.0344 183 44V44.1056C182.839 45.6362 175.885 48.5 171 48.5C164.402 48.5 159.057 46.4102 154.011 44.4369C149.497 42.6718 145.221 41 140.5 41C135.619 41 132.882 42.7867 130.08 44.616C127.142 46.5346 124.131 48.5 118.5 48.5C113 48.5 107.625 46.625 102.25 44.75C96.875 42.875 91.5 41 86 41C80.8792 41 79.0092 42.6253 77.0101 44.3628C74.715 46.3575 72.2499 48.5 64.5 48.5C56.5785 48.5 50.7461 46.2616 45.454 44.2305C41.0592 42.5437 37.0369 41 32.5 41C27.3683 41 23.9484 42.9751 20.6185 44.8981C17.4595 46.7225 14.3815 48.5 10 48.5ZM-8.5 69.5C-5.33333 71 2.8 74 10 74C14.3815 74 17.4595 72.2225 20.6185 70.3981C23.9484 68.4751 27.3683 66.5 32.5 66.5C37.0369 66.5 41.0592 68.0437 45.454 69.7305C50.7461 71.7616 56.5785 74 64.5 74C72.2499 74 74.715 71.8575 77.0101 69.8627C79.0092 68.1253 80.8792 66.5 86 66.5C91.5 66.5 96.875 68.375 102.25 70.25C107.625 72.125 113 74 118.5 74C124.131 74 127.142 72.0346 130.08 70.116C132.882 68.2867 135.619 66.5 140.5 66.5C145.221 66.5 149.497 68.1718 154.011 69.9369C159.057 71.9102 164.402 74 171 74C175.885 74 182.839 71.1362 183 69.6056V83.5C181.5 84.8333 177 87.5 171 87.5C164.149 87.5 158.2 85.2472 152.822 83.211C148.387 81.5319 144.341 80 140.5 80C136.25 80 132.875 81.875 129.5 83.75C126.125 85.625 122.75 87.5 118.5 87.5C114.186 87.5 107.939 85.5677 101.787 83.6648C95.8186 81.8186 89.9394 80 86 80C82.4831 80 80.4157 81.4494 78.0985 83.0739C75.1447 85.1447 71.7851 87.5 64.5 87.5C57.6533 87.5 52.0548 85.4196 46.7549 83.4502C41.9918 81.6803 37.47 80 32.5 80C27.0766 80 23.7074 82.0009 20.4496 83.9357C17.4001 85.7468 14.4481 87.5 10 87.5C6.16667 87.5 -2.9 86.6 -8.5 83V69.5ZM183 69.5V69.6056C183.004 69.5697 183.004 69.5344 183 69.5ZM10 99.5C2.8 99.5 -5.33333 96.5 -8.5 95V108.5C-2.9 112.1 6.16667 113 10 113C14.4481 113 17.4001 111.247 20.4496 109.436C23.7074 107.501 27.0766 105.5 32.5 105.5C37.47 105.5 41.9918 107.18 46.7549 108.95C52.0548 110.92 57.6533 113 64.5 113C71.7851 113 75.1447 110.645 78.0985 108.574C80.4157 106.949 82.4831 105.5 86 105.5C89.9394 105.5 95.8186 107.319 101.787 109.165C107.939 111.068 114.186 113 118.5 113C122.75 113 126.125 111.125 129.5 109.25C132.875 107.375 136.25 105.5 140.5 105.5C144.341 105.5 148.387 107.032 152.822 108.711C158.2 110.747 164.149 113 171 113C177 113 181.5 110.333 183 109V95.1056C183.004 95.0697 183.004 95.0344 183 95V95.1056C182.839 96.6362 175.885 99.5 171 99.5C164.402 99.5 159.057 97.4102 154.011 95.4369C149.497 93.6718 145.221 92 140.5 92C135.619 92 132.882 93.7867 130.08 95.616C127.142 97.5346 124.131 99.5 118.5 99.5C113 99.5 107.625 97.625 102.25 95.75C96.875 93.875 91.5 92 86 92C80.8792 92 79.0092 93.6253 77.0101 95.3627C74.715 97.3575 72.2499 99.5 64.5 99.5C56.5785 99.5 50.7461 97.2616 45.454 95.2305C41.0592 93.5437 37.0369 92 32.5 92C27.3683 92 23.9484 93.9751 20.6185 95.8981C17.4595 97.7225 14.3815 99.5 10 99.5Z"
                                    fill="white"
                                />
                            </svg>
                        </div>
                    </div>
                {/if}
            {/if}
        </div> -->
        </div>
    {/if}
</BaseAtom>

<style>
    .main-container {
        display: flex;
        flex-direction: row;
        padding: var(--mc-commentary-container-padding, unset);
        gap: 0.5rem;
        width: 100%;
        height: 100%;
        align-items: center;
        justify-content: space-around;
    }

    .overlapping-div {
        padding-bottom: var(--mc-commentary-overlap-width, 0);
    }
    .comment-content.single-column {
        grid-template-columns: 12fr !important;
    }
    .comment-content.single-column .commentary-box {
            padding-left: 1rem;
        }
    .main-container.mobile-layout .comment-content {
            grid-template-columns: 2.5fr 2fr 7.5fr;
        }
    .main-container.mobile-layout .comment-content.three-column {
            grid-template-columns: 2fr 8fr;
            -webkit-column-gap: 1rem;
               -moz-column-gap: 1rem;
                    column-gap: 1rem;
        }
    .main-container.mobile-layout .comment-content.two-column {
            grid-template-columns: 2.5fr 10fr;
        }
    .main-container.mobile-layout .player-off,
        .main-container.mobile-layout .player-on {
            width: 100%;
            display: flex;
            gap: 0.5rem;
            flex-wrap: wrap;
        }
    .main-container.mobile-layout .mins-text {
            padding: 0;
        }
    .main-container.mobile-layout .minutes {
            position: relative;
            height: 100%;
            justify-content: center;
        }
    .main-container.mobile-layout .comment-player-image {
            position: absolute;
            bottom: 0;
            left: 0;
        }
    .main-container.mobile-layout .title {
            margin-right: 2.5rem;
        }
    .main-container.mobile-layout .title-icon {
            position: absolute;
            top: 1rem;
            right: 0.5rem;
        }
    .main-container.tablet-layout .comment-content {
            grid-template-columns: 2fr 1fr 8fr 1fr;
        }
    .main-container.tablet-layout .comment-content.three-column {
            grid-template-columns: 2fr 9fr 1fr;
        }
    .main-container.tablet-layout .comment-content.two-column {
            grid-template-columns: 2fr 10fr;
        }
    .shape-content {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .circle-shape {
        width: 1.25rem;
        height: 1.25rem;
        background-color: var(--mc-commentary-shape-color);
        border-radius: 50%;
    }
    .circle-shape.gray-dot {
        background-color: var(--mc-commentary-shape-color-normal, #d0d0d0);
    }
    .line-shape-top,
    .line-shape-bot {
        flex: 0 0 50%;
        border-left: 4px solid var(--mc-commentary-line-color);
        max-height: calc(50% - 0.625rem);
    }
    .line-shape-top-plain {
        flex: 0 0 50%;
        border-left: 4px solid transparent;
        max-height: calc(50% - 0.625rem);
    }
    /* .line-shape-top {
        margin-top: -15px;
    }
    .line-shape-bottom {
        margin-bottom: -15px;
    } */
    .comment-content.apply-background {
        background: linear-gradient(180deg, #1f58b5 0%, #011858 100%);
        /* color: #fff; */
    }
    .comment-content.apply-background .comm-team-logo {
            align-self: flex-start;
        }
    .comment-content.apply-background .commentary-box {
            align-self: flex-start;
        }
    .comment-content.apply-gray-background {
        background-color: var(
            --mc-commentary-secondary-event-background,
            #d0d0d0
        );
    }
    .comment-content {
        position: relative;
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 0.5fr 9.5fr 1fr;
        align-items: center;
        /* justify-content: space-around; */
        grid-gap: 0.25rem;
        gap: 0.25rem;
        padding: 1rem;
        border-radius: 1.5rem;
        margin-top: 0.75rem;
        overflow: hidden;
        box-shadow: 0 2px 7px rgba(0, 0, 0, 0.15);
    }
    .comment-content.three-column {
        grid-template-columns: 1fr 10fr 1fr;
    }
    .comment-content.three-column .commentary-box {
            padding-left: 0.5rem;
        }
    .comment-content.two-column {
        grid-template-columns: 1fr 11fr;
    }
    .comment-content.two-column .commentary-box {
            padding-left: 0.5rem;
        }
    .bottom-content {
        width: 100%;
        max-width: 30rem;
        align-self: center;
        border-radius: 2rem;
        overflow: hidden;
    }
    .minutes {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
        padding-left: 1rem;
        /* height: 100%; */
    }
    .title {
        display: flex;
        align-items: flex-start;
        /* flex-wrap: wrap; */
        /* gap: 0.5rem; */
    }
    .comm-team-logo.mobile {
        align-self: center;
    }
    .title-icon {
        /* width: 3%; */
        align-self: flex-start;
        justify-self: flex-end;
    }
    .main-container.mobile-layout .title-icon.mobile {
            /* width: 15%;
            padding: 0 1rem; */
        }
    .rich-text-content {
        width: 100%;
    }
    .quote-content {
        border-left: 0.125rem solid
            var(--mc-commentary-quote-border-color, #000);
        padding: 0 1.5rem;
    }
    .mins-extras {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .mins-text {
        padding: 0.75rem 0;
    }
    .commentary-box {
        align-self: center;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }
    .player-off,
    .player-on {
        display: grid;
        align-items: center;
        grid-template-columns: 0.25fr 2fr 2fr;
        grid-gap: 0.5rem;
        gap: 0.5rem;
    }
    .photo-content {
        width: 100%;
        overflow: hidden;
        background-color: var(
            --theme-mode-highlight-color,
            var(--mc-commentary-photo-background-color, #0054a5)
        );

        display: flex;
        justify-content: center;
    }
    .photo-content .text-image {
            position: relative;
        }
    .photo-content .player-image {
            box-shadow: 10px 10px 2px var(--theme-mode-accent-color, #4ce0af);
            width: -webkit-min-content;
            width: -moz-min-content;
            width: min-content;
            height: -webkit-min-content;
            height: -moz-min-content;
            height: min-content;
            position: relative;
            z-index: 1;
            background-color: var(
                --theme-mode-highlight-color,
                var(--mc-commentary-photo-background-color, #0054a5)
            );
        }
    .photo-content .photo-text {
            position: absolute;
            top: 50%;
            z-index: 3;
            background-color: var(
                --theme-mode-highlight-color,
                var(--mc-commentary-photo-background-color, #0054a5)
            );
            padding: 0.25rem;
            margin-left: -2rem;
        }
    .photo-content .wave-pattern-bottom {
            align-self: flex-end;
            margin: -2rem 0 0 -2rem;
        }
    .photo-content .wave-pattern-bottom {
            margin: 0 -2rem 0 -2rem;
        }
    .minutes-text {
        display: flex;
        /* align-items: center; */
        gap: 0.25rem;
    }
    .comment-player-image {
        align-self: flex-start;
        margin-bottom: -1rem;
        margin-left: -1rem;
    }
    .sub-players {
        margin-top: 0.5rem;
        display: flex;
        flex-direction: column;
        gap: 0.05rem;
    }</style>
